import AWS from 'aws-sdk'
class AwsSdk {
  constructor(accessKeyId, secretAccessKey, bucket, endpoint, token) {
    this.s3 = new AWS.S3({
      accessKeyId: accessKeyId,
      secretAccessKey: secretAccessKey,
      sessionToken: token,
      region: 'cn-north-1',
      endpoint: endpoint,
      httpOptions: {
        agent: 'httpAgent'
      },
      sslEnabled: false,
      s3ForcePathStyle: true,
      apiVersion: '2006-03-01'
    })
    this.bucket = bucket
  }

  upload (f, key, tags, cd) {
    let that = this
    let params = {
      Bucket: this.bucket,
      Key: key,
      Body: f,
      ContentType: f.type
      // Expires: expires
    }
    let options = {
      partSize: 5 * 1024 * 1024,
      queueSize: 10
      // tags: tags
    }
    return new Promise(function (resolve, reject) {
      that.s3.upload(params, options, function (err, data) {
        if (err) {
          resolve(err)
        } else {
          resolve(data)
        }
      })
        .on('httpUploadProgress', function (e) {
          var precent = parseInt(e.loaded, 10) / parseInt(e.total, 10)
          precent = precent.toFixed(2) * 100
          cd(e)
        })
    })
  }

  async isExist (key) {
    let that = this
    let params = {
      Bucket: this.bucket,
      Key: key
    }
    return new Promise(function (resolve, reject) {
      that.s3.waitFor('objectExists', params, function (err, data) {
        if (err) {
          resolve(err)
        } else {
          resolve(data)
        }
      })
    })
  }

  async getObject (key) {
    let that = this
    let params = {
      Bucket: this.bucket,
      Key: key
    }
    return new Promise(function (resolve, reject) {
      that.s3.getObject(params, function (err, data) {
        if (err) {
          resolve(err)
        } else {
          resolve(data)
        }
      })
    })
  }
}
export default AwsSdk
